import React, { useEffect } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'

import Navbar from './Navbar'
import Sidebar from './Sidebar'
import Header from './Header'
import Dashboard from '../pages/Dashboard'
import UserList from '../pages/user/UserList'
import UserEdit from '../pages/user/UserEdit'
import UserCreate from '../pages/user/UserCreate'
import NotFound from '../pages/404'
import Footer from './Footer'
import { isLoggedIn } from "../user/User"
import Settings from '../pages/settings/Settings'
import Enable2FA from '../pages/settings/Enable2FA'
import ClientList from '../pages/client/ClientList'
import ClientCreate from '../pages/client/ClientCreate'
import ClientDelete from '../pages/client/ClientDelete'
import ClientEdit from '../pages/client/ClientEdit'
import TagList from '../pages/tag/TagList'
import TagCreate from '../pages/tag/TagCreate'
import TagDelete from '../pages/tag/TagDelete'
import TagEdit from '../pages/tag/TagEdit'
import SectorList from '../pages/sector/SectorList'
import SectorCreate from '../pages/sector/SectorCreate'
import SectorDelete from '../pages/sector/SectorDelete'
import SectorEdit from '../pages/sector/SectorEdit'
import ClientBoard from '../pages/client/ClientBoard'
import StatusList from '../pages/status/StatusList'
import StatusEdit from '../pages/status/StatusEdit'

function Wrapper({ appName }) {
    const navigate = useNavigate()
    useEffect(() => {
        if (!isLoggedIn()) {
            navigate("/login")
        }
    })

    return (
        <div className="app-wrapper">
            <Navbar />

            <Sidebar appName={appName} />

            <div className="app-main">
                <Header />

                <div className="app-content">
                    <div className="container-fluid">
                        <Routes>
                            <Route exact path="/" element={<Dashboard />} />

                            <Route exact path="/user" element={<UserList />} />
                            <Route exact path="/user/create" element={<UserCreate />} />
                            <Route path="/user/:id" element={<UserEdit />} />

                            <Route exact path="/settings" element={<Settings />} />
                            <Route exact path="/settings/enable2fa" element={<Enable2FA />} />

                            <Route exact path="/client" element={<ClientList />} />
                            <Route exact path="/client/board" element={<ClientBoard />} />
                            <Route exact path="/client/create" element={<ClientCreate />} />
                            <Route path="/client/delete/:id" element={<ClientDelete />} />
                            <Route path="/client/:id" element={<ClientEdit />} />

                            <Route exact path="/tag" element={<TagList />} />
                            <Route exact path="/tag/create" element={<TagCreate />} />
                            <Route path="/tag/delete/:id" element={<TagDelete />} />
                            <Route path="/tag/:id" element={<TagEdit />} />

                            <Route exact path="/sector" element={<SectorList />} />
                            <Route exact path="/sector/create" element={<SectorCreate />} />
                            <Route path="/sector/delete/:id" element={<SectorDelete />} />
                            <Route path="/sector/:id" element={<SectorEdit />} />

                            <Route exact path="/status" element={<StatusList />} />
                            <Route path="/status/:id" element={<StatusEdit />} />

                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </div>
                </div>
            </div>

            <Footer appName={appName} />

            <div className="sidebar-overlay"></div>
        </div>
    )
}

export default Wrapper
